<template>
  <v-tooltip v-if="eolStatus" location="bottom">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" class="popover-status-icon" variant="text">
        <v-icon color="grey" icon="mdi-alert-decagram" />
      </v-btn>
    </template>
    <span>
      {{ $t('device.warnings.sps.eol') }}
    </span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import type { GetterByDeviceId } from '@/components/devicePopover/types'

export default defineComponent({
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    id(): string {
      return this.deviceId || ''
    },
    eolStatus(): boolean {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SPS_EOL_BY_DEVICE_ID}`
      ] as GetterByDeviceId<boolean>
      return !!getter(this.id)
    }
  }
})
</script>
